import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import SiteDateSelector from "../SiteDateSelector";
import { getUrlParameterByName } from "../../../utils/utility";
import isUndefined from "lodash/isUndefined";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import remove from "lodash/remove";
import Select from "react-select";
import fetch from "isomorphic-fetch";
import queryString from "querystring";
import { apiBaseUrl } from "../../../env";
import HighlightOff from "material-ui/svg-icons/action/highlight-off";
import AlertError from "material-ui/svg-icons/alert/error";
import sortBy from "lodash/sortBy";
import find from "lodash/find";
import "../insights.css";
import { Link } from "react-router-dom";

const ASYNC_DELAY = 500;

class InsightFavoritePagesIndex extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = {
      filter: "",
      editMode: false,
      favoritePages: [],
      showMaxiumError: false,
    };
  }

  componentDidMount() {
    const tagId = parseInt(getUrlParameterByName("tag"), 10);
    const clientId = parseInt(getUrlParameterByName("cid"), 10);
    if (tagId > 0 && clientId > 0) {
      this.props.getClientSites(clientId);
      this.props.setWebsiteId(tagId);
      this.props.selectClient(clientId);
      this.props.fetchFavoritePages(tagId);
    } else if (clientId > 0 && isEmpty(tagId)) {
      this.props.getClientSites(clientId);
      this.props.selectClient(clientId);
      if (this.props.websiteId) {
        this.props.fetchFavoritePages(this.props.websiteId);
      }
    } else {
      this.props.selectClient(this.props.selected_client);
    }
  }

  getPages(input) {
    const tagId = parseInt(getUrlParameterByName("tag"), 10);
    if (!input || input.length < 3) {
      return Promise.resolve({ options: [] });
    }

    return fetch(
      `${apiBaseUrl}/insights/${tagId}/visited-url-paths?keyword=${input}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: this.props.token,
          "Cache-Control": "no-cache",
          "max-age": 0,
        },
      },
    )
      .then(response => response.json())
      .then(json => {
        return {
          options: map(json, item => {
            return { label: item, value: item };
          }),
        };
      });
  }

  filterOptions(options, filter, currentValues) {
    // Do no filtering, just return all options

    if (options) {
      const result = [];
      map(options, option => {
        if (
          find(this.state.favoritePages, p => {
            return p.pageUrl === option.value;
          }) === undefined
        ) {
          result.push({ label: option.label, value: option.value });
        }
      });
      return result;
    }
    return options;
  }

  onPageFilterChange(value) {
    if (!value) return;

    const { favoritePages } = this.state;
    let showMaxiumError = false;
    if (favoritePages.length < 20 && favoritePages.indexOf(value.value) < 0) {
      favoritePages.push({ pageUrl: value.value });
    } else {
      showMaxiumError = true;
    }
    this.setState({
      filter: value,
      favoritePages: favoritePages,
      editMode: true,
      showMaxiumError: showMaxiumError,
    });
  }

  componentWillReceiveProps(nextProps) {
    const clientId = parseInt(getUrlParameterByName("cid"), 10);
    const tagId = parseInt(getUrlParameterByName("tag"), 10);

    let alreadyFetch = false;
    if (nextProps.client_info) {
      if (nextProps.client_info.subscriptionTierId < 4) {
        this.props.history.push("/");
      }
    }

    if (nextProps.selected_client !== this.props.selected_client) {
      if (
        nextProps.selected_client !== clientId &&
        nextProps.selected_client > 1
      ) {
        window.location.href =
          "/distribution/pages/favorite?cid=" + nextProps.selected_client;
      }
      this.props.getClientInfo(nextProps.selected_client);
    }

    if (isUndefined(nextProps.websiteId) && tagId > 0) {
      this.props.setWebsiteId(tagId);
    }
    /*
    if (nextProps.websiteId !== this.props.websiteId) {
      if (nextProps.websiteId > 0) {
        if (tagId !== nextProps.websiteId) {
          const url =
            "/distribution/pages/favorite?cid=" +
            clientId +
            "&tag=" +
            nextProps.websiteId;
          window.location.href = url;
        } else {
          alreadyFetch = true;
          this.props.fetchFavoritePages(tagId);
        }
      }
    }*/

    if (!isEqual(nextProps.favoritePages, this.props.favoritePages)) {
      this.setState({
        favoritePages: Object.assign([], nextProps.favoritePages),
        /*
        editMode: !(
          nextProps.favoritePages && nextProps.favoritePages.length > 0
        ),*/
      });
    }
  }
  onWebSiteIdChanged(id) {
    const clientId = parseInt(getUrlParameterByName("cid"), 10);
    this.props.setWebsiteId(clientId);
    window.location.href =
      "/distribution/pages/favorite?cid=" + clientId + "&tag=" + id;
  }
  cancelEdit() {
    this.setState({
      favoritePages: Object.assign([], this.props.favoritePages),
      editMode: false,
      showMaxiumError: false,
      filter: "",
    });
  }

  removePage(pageUrl) {
    const { favoritePages } = this.state;
    remove(favoritePages, page => {
      return page.pageUrl === pageUrl;
    });
    this.setState({
      favoritePages: favoritePages,
      showMaxiumError: false,
    });
  }

  savePages() {
    const tagId = parseInt(getUrlParameterByName("tag"), 10);
    const { favoritePages } = this.state;
    const pages = map(favoritePages, p => {
      return { pageUrl: p.pageUrl };
    });
    this.props.saveFavoritePage(tagId, pages);
    this.setState({
      editMode: false,
      showMaxiumError: false,
      filter: "",
    });
  }

  render() {
    const { websiteId, client_sites } = this.props;
    const { favoritePages } = this.state;
    const tagId = parseInt(getUrlParameterByName("tag"), 10);
    const urlParams = queryString.parse(this.props.location.search);
    const cid = parseInt(getUrlParameterByName("cid"), 10);
    const type = getUrlParameterByName("type")
      ? getUrlParameterByName("type")
      : "default";

    return (
      <div id="segment-distribution-container">
        <div
          style={{
            margin: "-20px 10% 20px",
            fontSize: "16px",
            borderBottom: "solid 1px #EEEFF2",
          }}
        >
          <SiteDateSelector
            type={"larger"}
            key={"segment-distribution-site-selector-" + new Date().getTime()}
            websiteIdChanged={this.onWebSiteIdChanged.bind(this)}
            siteId={tagId ? tagId : websiteId}
            sites={client_sites}
          />
        </div>
        <div style={{ display: "flex", padding: "10px 10%", fontSize: "16px" }}>
          <div id="left-nav" style={{ flex: "0 0 260px" }}>
            <div className="light-grey-border">
              <div
                style={{
                  height: "48px",
                  padding: "15px 20px",
                  position: "relative",
                  background: "#F5F5F5",
                }}
              >
                <strong>Page Insights</strong>
              </div>
              <div
                onClick={() => {
                  this.props.history.push(
                    (
                      "/distribution/pages/popular" +
                      queryString.stringify(urlParams)
                    ).replace("%3F", "?"),
                  );
                }}
                style={{ height: "58px", padding: "15px 20px " }}
                className={"distribution-type"}
              >
                Most Popular Pages
              </div>
              <div
                onClick={() => {}}
                style={{ height: "58px", padding: "15px 20px" }}
                className="distribution-type-active"
              >
                Favorite Pages
              </div>
            </div>
          </div>
          {this.props.websiteId ? (
            <div style={{ width: "100%", flex: "1 0" }}>
              <div id="report-main" className="ml-20 light-grey-border p-20">
                <div>
                  <h1 className="no-margin">
                    <strong>Favorite Pages</strong>
                  </h1>
                </div>
                <div>
                  <div
                    style={{
                      display: "inline-block",
                      marginRight: "10px",
                    }}
                  >
                    <strong>Choose a favorite page</strong>
                  </div>
                  <Select.Async
                    className="pop-pages-selector"
                    value={this.state.filter}
                    loadOptions={this.getPages.bind(this)}
                    onChange={this.onPageFilterChange.bind(this)}
                    filterOptions={this.filterOptions.bind(this)}
                  />
                  {this.state.editMode && this.state.showMaxiumError && (
                    <div
                      style={{
                        color: "red",
                        paddingLeft: "200px",
                        paddingTop: "10px",
                      }}
                    >
                      <AlertError
                        style={{
                          fill: "#DD0000",
                          width: "16px",
                          height: "16px",
                        }}
                      />
                      Maximum of 20 favorited pages. Please remove a favorited
                      page below to continue
                    </div>
                  )}
                </div>
              </div>
              <div className="ml-20 light-grey-border p-20 mt-20">
                <div
                  style={{
                    padding: "20px 20px 20px",
                    background: "#F5F5F5",
                    display: "flex",
                  }}
                >
                  {this.state.editMode === true && (
                    <div style={{ width: "100px" }}>
                      <strong>Remove</strong>
                    </div>
                  )}
                  <div>
                    <strong>Page Name</strong>
                  </div>
                </div>
                <div
                  style={{
                    height: "400px",
                    paddingTop: "150px",
                    textAlign: "center",
                    display: this.props.loadingFavoritePages ? "block" : "none",
                  }}
                >
                  {this.props.loadingFavoritePages && (
                    <h1 style={{ display: "inline-block" }}>
                      Data loading, Please waiting...
                    </h1>
                  )}
                  {this.props.loadingFavoritePages && (
                    <img
                      src="/Spinner.gif"
                      style={{ marginLeft: "10px", height: "24px" }}
                    />
                  )}
                </div>
                {map(
                  sortBy(favoritePages, page => {
                    return page.pageUrl.substring(1);
                  }),
                  page => {
                    return (
                      <div
                        key={"page-" + page.pageUrl}
                        className="light-grey-border-bottom"
                        style={{ padding: "20px 20px 10px", display: "flex" }}
                      >
                        {this.state.editMode === true && (
                          <div
                            style={{
                              width: "100px",
                              paddingRight: "40px",
                              textAlign: "center",
                              cursor: "pointer",
                            }}
                          >
                            <HighlightOff
                              style={{ fill: "red" }}
                              onClick={() => {
                                this.removePage(page.pageUrl);
                              }}
                            />
                          </div>
                        )}
                        <div>
                          <Link
                            to={
                              "/segment-distribution?cid=" +
                              cid +
                              "&tag=" +
                              tagId +
                              "&page=" +
                              page.pageUrl +
                              "&type=" +
                              type +
                              "&source=fav"
                            }
                          >
                            {page.pageUrl}
                          </Link>
                        </div>
                      </div>
                    );
                  },
                )}
              </div>
              {this.state.editMode ? (
                <div
                  style={{
                    textAlign: "right",
                    marginTop: "20px",
                    marginBottom: "10px",
                  }}
                >
                  <button
                    className="aw-btn"
                    onClick={() => {
                      this.savePages();
                    }}
                  >
                    Save
                  </button>
                  <button
                    className="aw-btn-cancel ml-10 "
                    onClick={() => {
                      this.cancelEdit();
                    }}
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                <div
                  style={{
                    textAlign: "right",
                    marginTop: "20px",
                    marginBottom: "10px",
                  }}
                >
                  <button
                    className="aw-btn"
                    onClick={() => {
                      this.setState({ editMode: true });
                    }}
                  >
                    Edit
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div
              className="light-grey-border text-center p-20 ml-20 mb-20"
              id="contact-div"
              style={{
                color: "#DD0000",
                width: "100%",
                flex: "1 0",
                height: "450px",
              }}
            >
              <AlertError
                style={{
                  fill: "#DD0000",
                  width: "16px",
                  height: "16px",
                }}
              />{" "}
              No data to display try a different client
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default InsightFavoritePagesIndex;



// WEBPACK FOOTER //
// ./src/components/Insights/page/FavoritePages.js